// extracted by mini-css-extract-plugin
export default {"tooltip":"yn-z","sharingV2":"zn-z","sharingIconsV2":"An-z","links":"Bn-z","link":"Cn-z","facebookV2":"Dn-z","twitterV2":"En-z","pinterestV2":"Fn-z"};